import { createSelector } from "reselect";
import { tProductData, tProductCards } from "../types";

const getState = (state) => state.productReducer.product;

const productSelector = createSelector([getState], (item) => {

    let results:tProductData;

    if (item) {
        const { attributes } = item;

        let productCards:tProductCards[] = [];

        if (attributes && attributes.ProductCards && attributes.ProductCards && attributes.ProductCards.length > 0) {
            attributes.ProductCards.forEach(card => {

                let cardOptions: string[] = [];
                let cardFlipType: string = "both";

                if (card.CardOption && card.CardOption.length > 0) {
                    card.CardOption.forEach(option => {
                        cardOptions = [
                            ...cardOptions,
                            option.Caption,
                        ];
                    });
                }

                if (card.CardOption.length === 0 && card.Title) {
                    cardFlipType = "front";
                } else if (card.CardOption.length > 0 && !card.Title) {
                    cardFlipType = "back";
                }


                productCards = [
                    ...productCards,
                    {
                        id: card.id,
                        title: card.Title,
                        caption: card.Description,
                        image: card.Image && card.Image.data && card.Image.data.attributes.url && card.Image.data.attributes.url || null,
                        logo: card.ShowLogo && true || false,
                        cardOptions,
                        acronym: card.Acronym,
                        document: {
                            url: card.Document && card.Document.data && card.Document.data.attributes.url && card.Document.data.attributes.url || null,
                            title: card.Document && card.Document.data && card.Document.data.attributes.name && card.Document.data.attributes.name || null,
                        },
                        cardFlipType,
                    }
                ];
            });
        }

        results = {
            id: item.id,
            title: attributes && attributes.Title,
            description: attributes && attributes.Description,
            backLinkCaption: attributes && attributes.BackLinkCaption,
            image: attributes && attributes.Image && attributes.Image.data && attributes.Image.data.attributes.url && attributes.Image.data.attributes.url,
            productCards,
            reference: {
                image: attributes && attributes.Reference && attributes.Reference.Image && attributes.Reference.Image.data && attributes.Reference.Image.data.attributes.url && attributes.Reference.Image.data.attributes.url,
                title: attributes && attributes.Reference && attributes.Reference.Title,
                caption: attributes && attributes.Reference && attributes.Reference.Caption,
                url: attributes &&  attributes.Reference && attributes.Reference.Url,
                type: (attributes && attributes.Reference && attributes.Reference.Url && (attributes.Reference.Url.indexOf("https://") > -1 || attributes.Reference.Url.indexOf("http://") > -1)) && "outer" || "inner",
            },
        }
    }

    return results;
});

export default productSelector;
